var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardNewInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1141_564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1141_564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91687 9.1665V2.9165H9.16687V9.1665H2.91687ZM2.91687 17.0832V10.8332H9.16687V17.0832H2.91687ZM10.8335 9.1665V2.9165H17.0835V9.1665H10.8335ZM10.8335 17.0832V10.8332H17.0835V17.0832H10.8335ZM4.16687 7.9165H7.91687V4.1665H4.16687V7.9165ZM12.0835 7.9165H15.8335V4.1665H12.0835V7.9165ZM12.0835 15.8332H15.8335V12.0832H12.0835V15.8332ZM4.16687 15.8332H7.91687V12.0832H4.16687V15.8332Z",
    fill: "black",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardNewInactive);
export default __webpack_public_path__ + "static/media/dashboardNewInactive.ebcb5da1091d062e5a96abf90f793bbf.svg";
export { ForwardRef as ReactComponent };